<template>
  <div class="min-h-screen max-w-full m-auto bg-body">
    <SectionHeader />
    <SectionBanner />
    <SectionHowItWork />
    <SectionAboutUs />
    <SectionPhysician />
    <SectionArticle />
    <SectionFooter />
  </div>
</template>
<script>
import SectionHeader from "@/components/partials/onboarding/header.vue";
import SectionBanner from "@/components/partials/onboarding/banner.vue";
import SectionHowItWork from "@/components/partials/onboarding/howitwork.vue";
import SectionAboutUs from "@/components/partials/onboarding/aboutus.vue";
import SectionPhysician from "@/components/partials/onboarding/ourphysician.vue";
import SectionArticle from "@/components/partials/onboarding/article.vue";
import SectionFooter from "@/components/partials/onboarding/footer.vue";
export default {
  components: {
    SectionHeader,
    SectionBanner,
    SectionHowItWork,
    SectionAboutUs,
    SectionPhysician,
    SectionArticle,
    SectionFooter,
  },
  setup() {},
};
</script>
